import { apiClient } from '@copro/api';
import { useQuery } from '@tanstack/react-query';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

async function fetchExpenses(categoryIds: string[]) {
  const { data, error } = await apiClient
    .from('expenses')
    .select('*')
    .in('category_id', categoryIds)
    .order('month');

  if (error) {
    throw error;
  }

  return data;
}

/** Expenses of the given categories, oldest month first. */
export function useGetExpenses(categoryIds: string[]) {
  const { currentSpace } = useSpace();
  const sortedIds = [...categoryIds].sort();

  return useQuery({
    queryKey: keys.expensesByCategories(currentSpace?.id ?? '', sortedIds),
    queryFn: () => fetchExpenses(sortedIds),
    enabled: !!currentSpace?.id && sortedIds.length > 0,
  });
}
